module.exports = __webpack_public_path__ + "img/modal_info_icon.99d697b9.svg";